"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// ==========================================================================
// Scalable z-index (Do not edit the scale)
// https://gist.github.com/toadkicker/fc290e84d7bd861e3e73
// ==========================================================================
var zIndex = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];
var _default = exports.default = zIndex;